import { createClient } from "contentful";

export default createClient ({
    space:'f37r2cgrievn',
    accessToken:'iklyaSXvEnYVOXaimyW-S8uq_1xZtpXTOT9bWpmRpus'
})